import React, { useState } from 'react';

const WhatsappSender = () => {
  const [submit, setSubmit] = useState({
    phone_no: '',
    email: '',
    image_url: ''
  });

  const handleChange = (e) => {
    setSubmit({ ...submit, [e.target.name]: e.target.value });
  };

  const sendWhatsapp = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
    myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify({
    //   "messaging_product": "whatsapp",
    //   "recipient_type": "individual",
    //   // "to": `91${submit.phone_no}`,
    //   "to": "17654795238",
    //   "type": "template",
    //   "template": {
    //     "name": "hello_world",
    //     "language": {
    //       "code": "en_US"
    //     }
    //   },
    // });


    var raw = JSON.stringify({
      "messaging_product": "whatsapp",
      "recipient_type": "individual",
      "to": "918171461502",
      "type": "template",
      "template": {
        "name": "verify_otp ",
        "language": {
          "code": "en_US"
        },
        "components": [
          {
            "type": "body",
            "parameters": [
              {
                "type": "text",
                "text": "234442"
              },
              {
                "type": "text",
                "text": "99999999 999"
              },
            ]
          },
          {
            type: "button",
            sub_type: "url",      // ← Quick reply for copy-code
            index: "0",
            parameters: [
              { type: "payload", payload: "123456" }     // Same code to copy
            ]
          }

        ]

      },
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log('Success:', result);
        alert('Message sent successfully!');
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Failed to send message.');
      });
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Send WhatsApp Message</h2>
      <input
        type="text"
        name="phone_no"
        placeholder="Enter phone number"
        value={submit.phone_no}
        onChange={handleChange}
        style={{ margin: '10px', padding: '5px' }}
      />
      <input
        type="email"
        name="email"
        placeholder="Enter email"
        value={submit.email}
        onChange={handleChange}
        style={{ margin: '10px', padding: '5px' }}
      />
      <input
        type="text"
        name="image_url"
        placeholder="Enter image URL"
        value={submit.image_url}
        onChange={handleChange}
        style={{ margin: '10px', padding: '5px' }}
      />
      <button onClick={sendWhatsapp} style={{ padding: '10px 20px', cursor: 'pointer' }}>
        Send
      </button>
    </div>
  );
};

export default WhatsappSender;
